const constants = {
  header: {
    height: "60px",
  },
  footer: {
    height: "175px",
  },
  colors: {
    guava: "#fa2742",
    carob: "#373833",
    cream: "#f8faf3",
    sundew: "#f0e6d2",
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
};

export default constants;
